export enum MaintenanceTypes {
  Repair = "repair",
  Prevention = "prevention"
}